import { Box } from "@mui/material";
import React from "react";
import { PageSkeleton } from "./PageSkeleton";

interface PageLayoutProps {
  children: React.ReactNode;
  maxWidth?: boolean;
  isLoading?: boolean;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = false,
  isLoading = false,
}) => {
  const renderLayout = (content: React.ReactNode) => {
    if (!maxWidth) {
      return (
        <Box
          sx={{
            width: "100%",
            minWidth: 0,
            height: "100%",
            px: 3,
            pb: { xs: 3, md: 2 },
            pt: 0,
          }}
        >
          {content}
        </Box>
      );
    }

    return (
      <Box
        sx={{
          width: "100%",
          minWidth: 0,
          overflowX: "clip",
        }}
      >
        <Box
          sx={{
            px: { xs: 3, md: 2 },
            pt: { xs: 1, md: 4 },
            pb: { xs: 3, md: 2 },
            width: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          }}
        >
          {content}
        </Box>
      </Box>
    );
  };

  return renderLayout(
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        position: "relative",
        height: "auto",
        pt: { xs: 1, md: 4 },
      }}
    >
      <Box
        sx={(theme) => ({
          width: "100%",
          minWidth: 0,
          opacity: isLoading ? 0 : 1,
          pointerEvents: isLoading ? "none" : "auto",
          transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut,
          }),
        })}
      >
        {children}
      </Box>
      <Box
        aria-hidden
        sx={(theme) => ({
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          mt: { xs: 1, md: 4 },
          width: "100%",
          minWidth: 0,
          opacity: isLoading ? 1 : 0,
          transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut,
          }),
          pointerEvents: "none",
        })}
      >
        <PageSkeleton />
      </Box>
    </Box>,
  );
};
